/**
 * Service-collection GUIDs for the three default service collections (Best
 * Value, Cheapest, Fastest). Sourced verbatim from ss-ui-client's rate-shopper
 * selection list — these are the backend-recognized collection identifiers the
 * rating endpoint uses to resolve a winning service per default collection.
 */

export const BEST_VALUE_SERVICE_COLLECTION_GUID = 'b1c8f0d2-3e4f-4c5a-9b6d-7e8f9a0b1c2d';
export const FASTEST_SERVICE_COLLECTION_GUID = 'c2d3e4f5-6a7b-8c9d-0e1f-2a3b4c5d6e7f';
export const CHEAPEST_SERVICE_COLLECTION_GUID = 'ada7df25-768f-4400-8c71-410c1c957941';

/** Identifier for the three default service collections. */
export type DefaultServiceCollection = 'bestValue' | 'cheapest' | 'fastest';

const DefaultServiceCollectionGuids = new Set<string>([
  BEST_VALUE_SERVICE_COLLECTION_GUID,
  FASTEST_SERVICE_COLLECTION_GUID,
  CHEAPEST_SERVICE_COLLECTION_GUID,
]);

/** Maps a default service collection identifier to its backend GUID. */
export const GUID_BY_DEFAULT_SERVICE_COLLECTION: Record<DefaultServiceCollection, string> = {
  bestValue: BEST_VALUE_SERVICE_COLLECTION_GUID,
  cheapest: CHEAPEST_SERVICE_COLLECTION_GUID,
  fastest: FASTEST_SERVICE_COLLECTION_GUID,
};

const guidToDefaultServiceCollection: Record<string, DefaultServiceCollection> = {
  [BEST_VALUE_SERVICE_COLLECTION_GUID]: 'bestValue',
  [CHEAPEST_SERVICE_COLLECTION_GUID]: 'cheapest',
  [FASTEST_SERVICE_COLLECTION_GUID]: 'fastest',
};

export const getDefaultServiceCollectionByGuid = (serviceCollectionGuid: string): DefaultServiceCollection | null =>
  guidToDefaultServiceCollection[serviceCollectionGuid] ?? null;

export const isDefaultServiceCollectionGuid = (serviceCollectionGuid: string | undefined): boolean => {
  return serviceCollectionGuid ? DefaultServiceCollectionGuids.has(serviceCollectionGuid) : false;
};
